import { FC } from "react";

import { PrimaryText } from "@/components/Typography/Styled";

import {
    StyledSACollapseWrapper,
    StyledTotalSum,
    StyledTotalSumValue,
} from "./Styled";

interface ITotalSum {
    totalSum: number;
}

export const TotalSum: FC<ITotalSum> = ({ totalSum }) => (
    <StyledSACollapseWrapper>
        <StyledTotalSum>
            <PrimaryText>Всього:</PrimaryText>

            <StyledTotalSumValue>
                {totalSum.toLocaleString("uk-UA", {
                    minimumFractionDigits: 2,
                })}{" "}
                грн.
            </StyledTotalSumValue>
        </StyledTotalSum>
    </StyledSACollapseWrapper>
);
